var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "range" }, [
    _c("button", { staticClass: "decrease", on: { click: _vm.onDecrease } }, [
      _c("span")
    ]),
    _vm._v(" "),
    _c("input", {
      staticClass: "input",
      attrs: { step: "1", type: "range", min: _vm.min, max: _vm.max },
      domProps: { value: _vm.value },
      on: { input: _vm.onChange }
    }),
    _vm._v(" "),
    _c("button", { staticClass: "increase", on: { click: _vm.onIncrease } }, [
      _c("span")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }